import { render, staticRenderFns } from "./SupportTicketDialog.vue?vue&type=template&id=36e2f550&scoped=true"
import script from "./SupportTicketDialog.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2f550",
  null
  
)

export default component.exports